var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.shouldShowChatBot && _vm.showButton)?_c('div',{staticClass:"chat-button",on:{"click":_vm.loadChatBot}}):(_vm.isChatLoading)?_c('div',{staticClass:"spinner-container"},[_c('div',{staticClass:"spinner"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }